import { render, staticRenderFns } from "./actualityForm.vue?vue&type=template&id=4486a5cf&"
import script from "./actualityForm.vue?vue&type=script&lang=js&"
export * from "./actualityForm.vue?vue&type=script&lang=js&"
import style0 from "./actualityForm.vue?vue&type=style&index=0&id=4486a5cf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports